import { SceneHero, SceneHeroBridge } from "./home/SceneHero";
import { SceneIntro } from "./home/SceneIntro";
import { SceneServices } from "./home/SceneServices";
import { SceneCases } from "./home/SceneCases";
import { SceneMethod } from "./home/SceneMethod";
import { SceneSearchAI } from "./home/SceneSearchAI";
import { SceneConsultant } from "./home/SceneConsultant";
import { SceneResources } from "./home/SceneResources";
import { SceneFaq } from "./home/SceneFaq";
import { SceneDiagnosis } from "./home/SceneDiagnosis";
import type { Lang } from "./primitives";

/**
 * Composición completa de la Home en la dirección luminosa.
 * Una sola fuente de contenido por idioma: la usan tanto la Home pública
 * (`/`, `/en`) como el envoltorio noindex del laboratorio.
 */
export const HomeLuminous = ({ language = "es" as Lang }: { language?: Lang }) => (
  <>
    <SceneHero language={language} />
    <SceneHeroBridge language={language} />
    <SceneIntro language={language} />
    <SceneServices language={language} />
    <SceneCases language={language} />
    <SceneMethod language={language} />
    <SceneSearchAI language={language} />
    <SceneConsultant language={language} />
    <SceneResources language={language} />
    <SceneFaq language={language} />
    <SceneDiagnosis language={language} />
  </>
);
